module.exports = {
  defaultTitle: 'John Doe',
  logo: 'https://portfolio.smakosh.com/favicon/favicon-512.png',
  author: 'John Doe',
  url: 'https://portfolio.smakosh.com',
  legalName: 'John Doe',
  defaultDescription: 'I’m John and I’m a Backend & Devops engineer!',
  socialLinks: {
    twitter: 'http://www.twitter.com/smakosh',
    github: 'https://github.com/smakosh',
    linkedin: 'https://www.linkedin.com/in/ismail-ghallou-630149122/',
    instagram: 'https://instagram.com/smakosh19',
    youtube: 'https://www.youtube.com/user/smakoshthegamer',
    google: 'https://plus.google.com/u/0/+IsmailSmakoshGhallou',
  },
  googleAnalyticsID: 'UA-88875900-4',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    facebook: 'appId',
    twitter: '@smakosh',
  },
  address: {
    city: 'City',
    region: 'Region',
    country: 'Country',
    zipCode: 'ZipCode',
  },
  contact: {
    email: 'email',
    phone: 'phone number',
  },
  foundingDate: '2018',
};
